<template>
  <div class="layout">
    <div class="layout_nav">
      <!-- navegacion  -->
      <Nav v-bind="getRol"></Nav>
    </div>
    <div class="layout_center">
      <div class="layout_row">
        <div class="layout_colum">
          <Welcome v-bind="getUser"></Welcome>
          <!-- companyActive{{ companyActive }} -->
        </div>
        <div class="layout_colum">
          <div class="ctn_indicator"></div>
          <!-- {{ this.getAlert.snackbar }} -->
          <Snackbar
            v-bind:visible="getAlert.snackbar"
            v-bind:text="getAlert.text"
          ></Snackbar>
        </div>
      </div>
      <v-tabs v-model="tab">
        <v-tab key="user">Cuentas</v-tab>
        <v-tab key="profile">Perfiles</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item key="user">
          <div>
            <v-container fluid>
              <v-row>
                <v-col class="pa-0">
                  <div class="ctn_btn_new btn_left">
                    <v-btn
                      class="btn_new"
                      @click.stop="newUserFlag = true"
                      color="primary"
                    >
                      <v-icon>mdi-plus-circle-outline</v-icon>
                      <span>
                        Crear Usuario
                      </span>
                    </v-btn>
                  </div>
                </v-col>
                <v-col class="pa-0 py-3" sm="auto">
                  <div class="ctn_indicator">
                    <!-- indicador -->
                    <Indicator
                      v-bind:active="getListUsers.active"
                      v-bind:inactive="getListUsers.inactive"
                    ></Indicator>
                    <!-- btn crear  -->
                  </div>
                </v-col>
              </v-row>
            </v-container>
            <!-- tabla de datos -->
            <TableUser></TableUser>
            <NewUser
              :visible="newUserFlag"
              @close="newUserFlag = false"
            ></NewUser>
          </div>
        </v-tab-item>
        <v-tab-item key="profile">
          <div>
            <v-container fluid>
              <v-row>
                <v-col class="pa-0">
                  <div class="ctn_btn_new btn_left">
                    <v-btn
                      class="btn_new"
                      @click.stop="newProfileFlag = true"
                      color="primary"
                    >
                      <v-icon>mdi-plus-circle-outline</v-icon>
                      <span>
                        Crear perfil
                      </span>
                    </v-btn>
                  </div>
                </v-col>
                <v-col class="pa-0 py-3" sm="auto">
                  <div class="ctn_indicator">
                    <!-- indicador -->
                    <Indicator
                      v-bind:active="getListProfile.active"
                      v-bind:inactive="getListProfile.inactive"
                    ></Indicator>
                    <!-- btn crear  -->
                  </div>
                </v-col>
              </v-row>
            </v-container>
            <!-- tabla de datos -->
            <TableProfile></TableProfile>
            <NewProfile
              :visible="newProfileFlag"
              @close="newProfileFlag = false"
            ></NewProfile>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>
<script>
import Nav from "@/components/Nav.vue";
import Welcome from "@/components/Welcome.vue";
import Indicator from "@/components/Indicator.vue";
import Snackbar from "@/components/Snackbar.vue";
import TableUser from "@/components/user/Table.vue";
import TableProfile from "@/components/profile/Table.vue";
import NewProfile from "@/components/profile/New.vue";
import NewUser from "@/components/user/New.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "UserHome",
  components: {
    Nav,
    TableUser,
    NewUser,
    TableProfile,
    Welcome,
    Indicator,
    Snackbar,
    NewProfile,
  },
  data() {
    return {
      newUserFlag: false,
      newProfileFlag: false,
      tab: null,
      itemObjct: {},
    };
  },
  async mounted() {
    await this.listUser();
    await this.listProfile();
  },
  methods: {
    ...mapActions(["listUser", "listProfile"]),
  },
  computed: {
    ...mapGetters([
      "isLogin",
      "getRol",
      "isMaster",
      "getUser",
      "getListUsers",
      "getListProfile",
      "getAlert",
    ]),
    // profileActive() {
    //   let active = this.getListProfile
    //     .map((item) => {
    //       if (item.activate == 1) {
    //         return item;
    //       }
    //     })
    //     .filter((item) => {
    //       return item;
    //     });
    //   return active.length;
    // },
    // profileInactive() {
    //   let active = this.getListProfile
    //     .map((item) => {
    //       if (item.activate == 0) {
    //         return item;
    //       }
    //     })
    //     .filter((item) => {
    //       return item;
    //     });
    //   return active.length;
    // },
    // userActive() {
    //   let active = this.getListUsers
    //     .map((item) => {
    //       if (item.acount == 1) {
    //         return item
    //       }
    //     })
    //     .filter((item) => {
    //       return item
    //     })
    //   return active.length
    // },
    // userInactive() {
    //   let active = this.getListUsers
    //     .map((item) => {
    //       if (item.acount == 0) {
    //         return item
    //       }
    //     })
    //     .filter((item) => {
    //       return item
    //     })
    //   return active.length
    // },
  },
};
</script>
<style lang="scss" scoped>
.v-item-group {
  margin: 0 10px;
  overflow: visible;
}
</style>
